import { useState, useEffect } from "react";
import { useStyles } from "./modalContent";

const ReusableComprehensiveCostModal = ({
  isOpen,
  onClose,
  mode,
  providerData,
  onSubmit,
  onDelete,
}) => {
  const classes = useStyles();

  // Initialize formData based on providerData for edit/create modes
  const [formData, setFormData] = useState({
    name: providerData?.name || "",
    price: providerData?.price || "", // Use price instead of tests
  });
  const [error, setError] = useState(null);

  // Update formData when providerData changes
  useEffect(() => {
    setFormData({
      name: providerData?.name || "",
      price: providerData?.price || "", // Initialize with price
    });
  }, [providerData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!formData.name || !formData.price) {
      setError("Name and Price are required.");
      return false;
    }
    if (isNaN(formData.price) || Number(formData.price) <= 0) {
      setError("Price must be a valid positive number.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    setError(null);
    if ((mode === "edit" || mode === "create") && !validateForm()) return;

    try {
      const payload = {
        name: formData.name,
        price: Number(formData.price), // Ensure price is a number
      };

      if (mode === "edit") {
        await onSubmit(providerData.id, payload);
      } else if (mode === "create") {
        await onSubmit(null, payload);
      } else if (mode === "delete") {
        await onDelete(providerData.id);
      }
      onClose();
    } catch (err) {
      setError("Operation failed. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "500px",
          boxShadow: "0 8px 10px rgba(0, 0, 0, 0.1)",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <h2>
          {mode === "view"
            ? "View Comprehensive Cost Plan"
            : mode === "edit"
            ? "Edit Comprehensive Cost Plan"
            : mode === "create"
            ? "Create Comprehensive Cost Plan"
            : "Delete Comprehensive Cost Plan"}
        </h2>
        {error && <p style={{ color: "red" }}>{error}</p>}

        {mode === "view" && (
          <div>
            <p>
              <strong>Plan Name:</strong> {providerData?.name || "N/A"}
            </p>
            <p>
              <strong>Price:</strong>{" "}
              {providerData?.price ? `$${providerData.price}` : "N/A"}
            </p>
          </div>
        )}

        {(mode === "edit" || mode === "create") && (
          <form>
            <div>
              <label className={classes.enroleeIdText}>Plan Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              />
            </div>
            <div>
              <label className={classes.enroleeIdText}>Price:</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleChange}
                className={classes.enroleeInputId}
                min="0"
                step="1"
                style={{ width: "100%" }}
                placeholder="Enter price (e.g., 54000)"
                required
              />
            </div>
          </form>
        )}

        {mode === "delete" && (
          <p>
            Are you sure you want to delete the {providerData?.name}{" "}
            comprehensive care plan?
          </p>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "#ccc",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {mode === "view" ? "Close" : "Cancel"}
          </button>
          {(mode === "edit" || mode === "create" || mode === "delete") && (
            <button
              onClick={handleSubmit}
              style={{
                padding: "8px 16px",
                background: mode === "delete" ? "#d32f2f" : "#1976d2",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              {mode === "edit"
                ? "Save"
                : mode === "create"
                ? "Create"
                : "Delete"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReusableComprehensiveCostModal;
